import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import BatchSubproyectoTable from "../components/Proyecto/BatchSubproyectoTable";
import NewBatchSubproyectoModal from "../components/Proyecto/NewBatchSubproyectoModal";
import axios from "axios";
import { API_URL_subproyectos } from "../constants";

import { getAuthHeaders } from "../utils/auth";
const SubproyectoBatch = () => {
  const [subproyectos, setSubproyectos] = useState([]);

  const fetchSubproyectos = async () => {
    const headers = getAuthHeaders();

    try {
      const response = await axios.get(API_URL_subproyectos, { headers });
      setSubproyectos(response.data);
    } catch (error) {
      console.error("Error fetching subproyectos:", error.response?.data || error.message);
    }
  };

  useEffect(() => {
    fetchSubproyectos();
  }, []);

  const containerStyle = { marginTop: "20px" };

  return (
    <Container style={containerStyle}>
      <Row>
        <Col>
          <BatchSubproyectoTable subproyectos={subproyectos} resetState={fetchSubproyectos} />
        </Col>
      </Row>
    </Container>
  );
};

export default SubproyectoBatch;